import { render } from "./company_m_Soshiki.vue?vue&type=template&id=d8583922"
import script from "./company_m_Soshiki.vue?vue&type=script&lang=js"
export * from "./company_m_Soshiki.vue?vue&type=script&lang=js"

import "./company_m_Soshiki.vue?vue&type=style&index=0&id=d8583922&lang=css"

import exportComponent from "/codebuild/output/src327471177/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__